import { jsx } from 'react/jsx-runtime';
import { IconNavigational24Note } from '@fabric-app/icons/svg';

const ResourcePreviewListItemNote = () => {
  return /* @__PURE__ */ jsx(IconNavigational24Note, {});
};

export { ResourcePreviewListItemNote };
//# sourceMappingURL=ResourcePreviewListItemNote.js.map
